import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { Container, Button, Options, Item } from './HeaderDropdownStyles';
import { ArrowDown } from 'components/Icons/ArrowDown';
import { ArrowUp } from 'components/Icons';

/*
If using the custom option, there is no good way to trigger closing of the dropdown.
In this case use the selectedItem variable to trigger a close. Every time a selection
changes the dropdown will close. 
*/
type Props = {
  options?: any;
  styles?: any;
  customOption?: any;
  selectedItem?: any;
  onItemClick?: (title: string) => void;
};

const HeaderDropdown: React.FC<Props> = ({
  children,
  options,
  styles,
  customOption,
  selectedItem,
  onItemClick,
}) => {
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (customOption && typeof selectedItem !== 'undefined') {
      setActive(false);
    }
  }, [customOption, selectedItem]);

  const DropdownIcon = () =>
    !active ? (
      <ArrowDown fill={'#fff'} size='12px' />
    ) : (
      <ArrowUp fill={'#fff'} size='12px' />
    );

  return (
    <Container>
      <OutsideClickHandler onOutsideClick={() => setActive(false)}>
        <Button onClick={() => setActive(!active)}>
          {children} <DropdownIcon />
        </Button>
        {active && customOption ? customOption : null}
        {active && !customOption && (
          <Options styles={styles?.Options}>
            {options?.map((item: any) => (
              <Item
                key={item.title}
                onClick={() => {
                  setActive(false);
                  onItemClick?.(item.title);
                }}
              >
                {item.icon && item.icon} {item.title}
              </Item>
            ))}
          </Options>
        )}
      </OutsideClickHandler>
    </Container>
  );
};

export default HeaderDropdown;
